import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const StatsSection = () => {
  const [counters, setCounters] = useState({
    consultations: 0,
    satisfaction: 0,
    lawyers: 0,
    documents: 0,
  });

  const finalStats = {
    consultations: 12500,
    satisfaction: 98,
    lawyers: 150,
    documents: 8200,
  };

  const stats = [
    {
      id: 'consultations',
      title: 'مشاوره انجام شده',
      value: counters?.consultations,
      suffix: '+',
      icon: 'MessageCircle',
      color: 'text-primary',
    },
    {
      id: 'satisfaction',
      title: 'رضایت کاربران',
      value: counters?.satisfaction,
      suffix: '%',
      icon: 'Heart',
      color: 'text-success',
    },
    {
      id: 'lawyers',
      title: 'وکیل متخصص',
      value: counters?.lawyers,
      suffix: '+',
      icon: 'Users',
      color: 'text-secondary',
    },
    {
      id: 'documents',
      title: 'سند بررسی شده',
      value: counters?.documents,
      suffix: '+',
      icon: 'FileCheck',
      color: 'text-accent',
    },
  ];

  useEffect(() => {
    const duration = 2000; // Animation duration in milliseconds
    const steps = 60; // Number of animation steps
    const stepDuration = duration / steps;

    const intervals = Object.keys(finalStats)?.map((key) => {
      const finalValue = finalStats?.[key];
      const increment = finalValue / steps;
      let currentValue = 0;

      return setInterval(() => {
        currentValue += increment;
        if (currentValue >= finalValue) {
          currentValue = finalValue;
          clearInterval(
            intervals?.find(
              (interval) =>
                interval === intervals?.[Object.keys(finalStats)?.indexOf(key)]
            )
          );
        }

        setCounters((prev) => ({
          ...prev,
          [key]: Math.floor(currentValue),
        }));
      }, stepDuration);
    });

    return () => {
      intervals?.forEach((interval) => clearInterval(interval));
    };
  }, []);

  return (
    <section className="py-16 lg:py-24 bg-backgorund">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            آمار و اعداد
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            اعتماد هزاران کاربر و نتایج قابل اعتماد در خدمات حقوقی
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {stats?.map((stat, index) => (
            <motion.div
              key={stat?.id}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
              className="group">
              <div className="bg-card rounded-2xl p-6 lg:p-8 text-center border border-border hover:border-primary/20 transition-all duration-300 shadow-subtle hover:shadow-moderate">
                {/* Icon */}
                <div
                  className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-${stat?.color?.replace(
                    'text-',
                    ''
                  )}/10 to-${stat?.color?.replace(
                    'text-',
                    ''
                  )}/5 mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={stat?.icon} size={32} className={stat?.color} />
                </div>

                {/* Counter */}
                <div className="mb-2">
                  <span className="text-3xl lg:text-4xl font-bold text-foreground">
                    {stat?.value?.toLocaleString('fa-IR')}
                  </span>
                  <span
                    className={`text-2xl lg:text-3xl font-bold ${stat?.color}`}>
                    {stat?.suffix}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-sm lg:text-base font-medium text-muted-foreground group-hover:text-foreground transition-colors duration-300">
                  {stat?.title}
                </h3>

                {/* Animated border */}
                <div
                  className={`mt-4 h-1 bg-gradient-to-r from-transparent via-${stat?.color?.replace(
                    'text-',
                    ''
                  )} to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full`}></div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 text-center">
          <div className="inline-flex items-center px-6 py-3 bg-success/10 text-success rounded-full text-sm font-medium">
            <Icon name="TrendingUp" size={16} className="ml-2" />
            آمار در حال رشد و به‌روزرسانی روزانه
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
